'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BundlePage = require('./BundlePage');

var _PlanButton = require('./PlanButton');

var _PlanButton2 = _interopRequireDefault(_PlanButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServicePlanButton(_ref) {
  var merchandiseId = _ref.merchandiseId,
      edition = _ref.edition;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      mergeState = _useContext.mergeState;

  var servicePlanSelected = state.servicePlanSelected;

  var onSelectedChange = function onSelectedChange() {
    var updatedSelectedMerch = servicePlanSelected === merchandiseId ? null : merchandiseId;
    mergeState({
      servicePlanSelected: updatedSelectedMerch,
      serviceUnits: 0
    });
  };

  return _react2.default.createElement(_PlanButton2.default, {
    edition: edition,
    merchandiseId: merchandiseId,
    selected: servicePlanSelected === merchandiseId,
    onSelectedChange: onSelectedChange
  });
}

exports.default = ServicePlanButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/ServicePlanButton.js
// module id = 704
// module chunks = 3 4